import React, { useEffect, useState } from 'react';
import '../../styles/realsignal-theme.css';

interface LoadingScreenProps {
    onLoadComplete?: () => void;
    minDisplayTime?: number;
}

export const LoadingScreen: React.FC<LoadingScreenProps> = ({
    onLoadComplete,
    minDisplayTime = 2000,
}) => {
    const [isVisible, setIsVisible] = useState(true);
    const [isFadingOut, setIsFadingOut] = useState(false);

    useEffect(() => {
        const fadeTimer = setTimeout(() => {
            setIsFadingOut(true);
        }, minDisplayTime);

        const completeTimer = setTimeout(() => {
            setIsVisible(false);
            onLoadComplete?.();
        }, minDisplayTime + 500); // 500ms fade duration

        return () => {
            clearTimeout(fadeTimer);
            clearTimeout(completeTimer);
        };
    }, [minDisplayTime, onLoadComplete]);

    if (!isVisible) return null;

    return (
        <div
            style={{
                position: 'fixed',
                inset: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: '#0F1A24',
                zIndex: 9999,
                opacity: isFadingOut ? 0 : 1,
                transition: 'opacity 500ms ease-out',
            }}
        >
            {/* Texture overlay - grainy noise blended with navy background */}
            <div
                style={{
                    position: 'absolute',
                    inset: 0,
                    backgroundImage: 'url(/assets/realsignal-bg-texture.jpg)',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    opacity: 0.12,
                    mixBlendMode: 'luminosity',
                    filter: 'grayscale(100%)',
                    pointerEvents: 'none',
                }}
            />
            <div className="absolute inset-0 overflow-hidden">
                <div
                    className="absolute top-1/4 left-1/4 w-96 h-96 rounded-full blur-3xl"
                    style={{ background: 'rgba(58, 106, 122, 0.15)' }}
                />
                <div
                    className="absolute bottom-1/4 right-1/4 w-96 h-96 rounded-full blur-3xl"
                    style={{ background: 'rgba(46, 74, 90, 0.12)' }}
                />
            </div>
            <div className="relative z-10 flex flex-col items-center">
                <img
                    src="/assets/realsignal-logo-solo.png"
                    alt="RealSignal"
                    style={{
                        width: '80px',
                        height: 'auto',
                        animation: 'rs-pulse 2s ease-in-out infinite',
                        filter: 'drop-shadow(0 0 30px rgba(58, 106, 122, 0.4))',
                    }}
                />
            </div>
            <style>{`
        @keyframes rs-pulse {
          0%, 100% {
            transform: scale(1);
            filter: drop-shadow(0 0 30px rgba(58, 106, 122, 0.4));
          }
          50% {
            transform: scale(1.05);
            filter: drop-shadow(0 0 50px rgba(58, 106, 122, 0.6));
          }
        }
      `}</style>
        </div>
    );
};

export default LoadingScreen;
